import '@convergence/components/dist/components.css';
import { AnimatePresence } from 'motion/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CheckoutReturn } from '../components/checkout/CheckoutReturn';
import { RequireAuth } from '../components/RequireAuth';
import { AppLayout } from '../layouts/AppLayout/AppLayout';
import { Checkout } from './Checkout';
import { Home } from './Home';
import Contact from './Home/Contact';
import { Landing } from './Landing';
import { NotebookTest } from './NotebookTest';
import { Pricing } from './Pricing';
import { Providers } from './Providers';
import { NodesTest } from './NodesTest/NodesTest';

export function App() {
  return (
    <Providers>
      <BrowserRouter>
        <AnimatePresence>
          <Routes>
            <Route path="/">
              <Route index element={<Landing />}></Route>
              <Route path="pricing" element={<Pricing />} />
              <Route path="contact" element={<Contact />} />
              <Route path="test" element={<NodesTest />} />
              <Route path="checkout">
                <Route index element={<Checkout />} />
                <Route path="return" element={<CheckoutReturn />} />
              </Route>
              <Route path="app" element={<AppLayout />}>
                <Route
                  index
                  element={
                    <RequireAuth>
                      <Home />
                    </RequireAuth>
                  }
                />
              </Route>
            </Route>
          </Routes>
        </AnimatePresence>
      </BrowserRouter>
    </Providers>
  );
}
